import {
  PermissionsApplication as Data,
  PermissionsApplicationCollection as Collection,
} from '@/typings/api/PermissionsApplication'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class PermissionsApplicationsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'permissions/applications';
}
